import React, { Component } from 'react';
import PropTypes from "prop-types";
import Button from "../../../../../components/UI/Button";
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import { alert } from '../../../../../common/Utils'
import { formatDate } from "../../../../../common/Utils"
import { toast } from "react-toastify";
import { API_URL, ERROR_HANDLE } from "config/constants";
import axios from "axios";
import moment from "moment";

const DONE_TEXT = "DONE";
const RESET_TEXT = "RESET";
const EDIT_SESSION_TITLE = "EDIT SESSION";
const CHECKIN_TIME_TEXT = "Checkin Time: ";
const CHECKOUT_TIME_TEXT = "Checkout Time: ";
const COST_TEXT = "Cost: ";
const MINUTES_SPENT_TEXT = "Minutes Spend: ";
const ALERT_MINUTES_SPENT = "Minutes entered is exceeding than the actual checkout time ";
const ALERT_GYM_TIME = "Minutes entered is exceeding than the current time";
const ALERT_MINUTES_ZERO = "Minutes entered should be greater than zero";

class EditSession extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minutesSpent: this.props.minutesSpent ? Math.round(this.props.minutesSpent) : 0,
            minutesSpentBackup: this.props.minutesSpent ? Math.round(this.props.minutesSpent) : 0
        }
    }

    checkoutSession = () => {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Checking out session...");
        axios.post(`${API_URL}/admin/checkout/${this.props.sessionId}`, null, {
            params: {
                "minutesSpend": this.state.minutesSpent
            },
            headers: {
                "x-access-token": access_token
            },
        }).then(() => {
            toast.dismiss(toastId);
            this.props.updateCurrentSession()
            toast("Checked out Successfully", { autoClose: 1500 });
        }).catch(err => {
            toast.dismiss(toastId);
            setTimeout(() => {
                ERROR_HANDLE(err);
            }, 500);
        });
    }

    editSession = () => {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Editing session...");
        axios.put(`${API_URL}/admin/session/${this.props.sessionId}`, null, {
            params: {
                "minutesSpend": this.state.minutesSpent
            },
            headers: {
                "x-access-token": access_token
            },
        }).then((response) => {
            toast.dismiss(toastId);
            this.props.updateSession(response.data);
            toast("Edited session Successfully", { autoClose: 1500 });
        }).catch(err => {
            toast.dismiss(toastId);
            setTimeout(() => {
                ERROR_HANDLE(err);
            }, 500);
        });
    };

    validateMinutesSpent() {
        //condition to check minutes entered is greater than zero
        if (this.state.minutesSpent <= 0) {
            alert(ALERT_MINUTES_ZERO)
            return false
        }
        const gymCurrentTime = formatDate(new Date(), this.props.timeZone);
        let checkOut = this.props.checkInTime
        checkOut = new Date(checkOut.getTime() + this.state.minutesSpent * 60000);
        let isValid = true;
        if (this.props.checkOutTime) {
            const actualCheckout = this.props.actualCheckoutTime ? this.props.actualCheckoutTime : this.props.checkOutTime
            if (checkOut > actualCheckout) {
                const actualCheckoutDate = actualCheckout ? moment(new Date(actualCheckout)).format('DD-MMM-YYYY') : "-"
                const actualCheckoutTime = actualCheckout ? moment(new Date(actualCheckout)).format('hh:mm:ss A') : "-"
                alert(ALERT_MINUTES_SPENT + actualCheckoutDate + " " + actualCheckoutTime);
                isValid = false
            } else {
                isValid = true
            }
        } else {
            if (checkOut > gymCurrentTime) {
                alert(ALERT_GYM_TIME)
                isValid = false
            } else {
                isValid = true
            }
        }
        return isValid
    }

    render() {
        const checkinDate = this.props.checkInTime ? moment(new Date(this.props.checkInTime)).format('DD-MMM-YYYY') : "-"
        const checkinTime = this.props.checkInTime ? moment(new Date(this.props.checkInTime)).format('hh:mm:ss A') : "-"
        const checkoutDate = this.props.checkOutTime ? moment(new Date(this.props.checkOutTime)).format('DD-MMM-YYYY') : "-"
        const checkoutTime = this.props.checkOutTime ? moment(new Date(this.props.checkOutTime)).format('hh:mm:ss A') : "-"
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={EDIT_SESSION_TITLE}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}
            >
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>
                        {CHECKIN_TIME_TEXT} &nbsp; &nbsp;
                                </p>
                    <p style={style.selectorValue}>{checkinDate + "\n" + checkinTime}</p>
                </div>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>
                        {CHECKOUT_TIME_TEXT} &nbsp; &nbsp;
                                </p>
                    <p style={style.selectorValue}>{checkoutDate + "\n" + checkoutTime}</p>
                </div>
                {
                    this.props.cost > 0 && <div style={style.selectorWrapper}>
                        <p style={style.selectorLabel}>
                            {COST_TEXT} &nbsp; &nbsp;
                        </p>
                        <p style={style.selectorValue}>{"$" + this.props.cost}</p>
                    </div>
                }
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>
                        {MINUTES_SPENT_TEXT} &nbsp; &nbsp;
                                </p>
                    <input
                        value={this.state.minutesSpent}
                        style={{ ...style.input, ...{ backgroundColor: theme.color.textLightWhite } }}
                        onChange={e => {
                            if (!isNaN(e.target.value) && !e.target.value.includes(".")) {
                                this.setState({
                                    minutesSpent: e.target.value
                                });
                            }
                        }}
                    />
                </div>
                <div style={style.doneButtonWrapper}>
                    <Button
                        style={style.doneButton}
                        type="primary"
                        onClick={() => {
                            if (this.validateMinutesSpent()) {
                                if (this.props.checkOutTime) {
                                    //Edit API call
                                    this.props.sessionId && this.editSession();
                                } else {
                                    //Checkout API call
                                    this.props.sessionId && this.checkoutSession()
                                }
                            }
                        }}
                    >
                        {DONE_TEXT}
                    </Button>
                    <Button
                        style={style.doneButton}
                        type="primary"
                        onClick={() => this.setState({ minutesSpent: this.state.minutesSpentBackup })}
                    >
                        {RESET_TEXT}
                    </Button>
                </div>
            </ModalOverlay >
        )
    }
}

EditSession.propTypes = {
    sessionId: PropTypes.string.isRequired,
    checkInTime: PropTypes.string.isRequired,
    checkOutTime: PropTypes.string.isRequired,
    actualCheckoutTime: PropTypes.string.isRequired,
    cost: PropTypes.string.isRequired,
    minutesSpent: PropTypes.string.isRequired,
    timeZone: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    updateSession: PropTypes.func.isRequired,
    updateCurrentSession: PropTypes.func.isRequired
};

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    selectorWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "nowrap",
        height: 90
    },
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px",
        width: "150px",
        textAlign: "left",
        height: 20
    },
    input: {
        border: "1px solid #444445",
        borderRadius: 50,
        fontSize: 18,
        color: theme.color.primaryBlue,
        padding: 10,
        paddingLeft: 20,
        minWidth: 200,
        textAlign: "left",
        backgroundColor: theme.color.textLightWhite
    },
    selectorValue: {
        fontSize: 18,
        color: theme.color.primaryBlue,
        padding: 10,
        paddingLeft: 20,
        minWidth: 200,
        textAlign: "left",
        height: 20
    },
    doneButtonWrapper: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 20
    },
    doneButton: {
        width: "180px",
        fontSize: "20px"
    }
};

export default EditSession;

